import styled from 'styled-components';

export const StyledContainer = styled.div`
  width: 100%;
`;
